(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

    /* ============================================
       Enhanced Tabs UX
       ============================================ */
    const sections = document.querySelectorAll('.section-product-tabs');

    sections.forEach(function(section){
      const tabsList = section.querySelector('.tabs-list');
      const tabTitles = section.querySelectorAll('.tab-title');
      const tabContents = section.querySelectorAll('.tab-content');
      const tabsContent = section.querySelector('.tabs-content');
      if (!tabsList || !tabTitles.length || !tabContents.length) return;

      const enableSwipe = section.dataset.enableSwipe === 'true';
      const enableKeyboard = section.dataset.enableKeyboard === 'true';

      // ARIA + tablist semantics
      tabsList.setAttribute('role', 'tablist');
      tabTitles.forEach(function(t){
        t.setAttribute('role', 'tab');
        t.setAttribute('aria-selected', t.classList.contains('is-active') ? 'true' : 'false');
        t.setAttribute('tabindex', t.classList.contains('is-active') ? '0' : '-1');
      });
      tabContents.forEach(function(c){
        c.setAttribute('role', 'tabpanel');
        c.setAttribute('tabindex', '0');
      });

      // Sliding indicator (CSS vars on tabs-list)
      function updateIndicator(){
        const active = tabsList.querySelector('.tab-title.is-active');
        if (!active) return;
        const listRect = tabsList.getBoundingClientRect();
        const rect = active.getBoundingClientRect();
        const x = rect.left - listRect.left + tabsList.scrollLeft;
        tabsList.style.setProperty('--ind-x', x + 'px');
        tabsList.style.setProperty('--ind-w', rect.width + 'px');
      }

      function activateByIndex(index){
        if (index < 0 || index >= tabTitles.length) return;
        const title = tabTitles[index];
        if (title.classList.contains('is-active')) return;

        tabTitles.forEach(function(t){
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
          t.setAttribute('tabindex', '-1');
        });
        tabContents.forEach(function(c){ c.classList.remove('is-active'); });

        title.classList.add('is-active');
        title.setAttribute('aria-selected', 'true');
        title.setAttribute('tabindex', '0');

        setTimeout(function(){
          tabContents[index].classList.add('is-active');
        }, 10);

        updateIndicator();

        try {
          title.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        } catch(e){}
      }

      tabTitles.forEach(function(title, i){
        title.addEventListener('click', function(e){
          e.preventDefault();
          activateByIndex(i);
        });
      });

      if (enableKeyboard) {
        tabsList.addEventListener('keydown', function(e){
          const currentIdx = Array.prototype.findIndex.call(tabTitles, function(t){ return t.classList.contains('is-active'); });
          let nextIdx = currentIdx;
          if (e.key === 'ArrowRight') nextIdx = (currentIdx + 1) % tabTitles.length;
          else if (e.key === 'ArrowLeft') nextIdx = (currentIdx - 1 + tabTitles.length) % tabTitles.length;
          else if (e.key === 'Home') nextIdx = 0;
          else if (e.key === 'End') nextIdx = tabTitles.length - 1;
          else return;
          e.preventDefault();
          activateByIndex(nextIdx);
          tabTitles[nextIdx].focus();
        });
      }

      if (enableSwipe && tabsContent){
        let touchStartX = 0, touchStartY = 0, touchStartT = 0;
        tabsContent.addEventListener('touchstart', function(e){
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          touchStartT = Date.now();
        }, { passive: true });
        tabsContent.addEventListener('touchend', function(e){
          const dx = e.changedTouches[0].clientX - touchStartX;
          const dy = e.changedTouches[0].clientY - touchStartY;
          const dt = Date.now() - touchStartT;
          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5 && dt < 600){
            const currentIdx = Array.prototype.findIndex.call(tabTitles, function(t){ return t.classList.contains('is-active'); });
            const nextIdx = dx < 0
              ? Math.min(currentIdx + 1, tabTitles.length - 1)
              : Math.max(currentIdx - 1, 0);
            if (nextIdx !== currentIdx) activateByIndex(nextIdx);
          }
        }, { passive: true });
      }

      window.addEventListener('resize', updateIndicator);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(updateIndicator);
      }
      setTimeout(updateIndicator, 100);
      setTimeout(updateIndicator, 500);
    });

    /* ============================================
       Original accordion / drawer / popup toggles
       ============================================ */
    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelector('.tab-title-text');
        if (tabTitleText) {
          tabTitleText.textContent = toggleLink.textContent;
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('.drawer-content-wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });

    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');

      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
  });

  } catch(e) { console.error(e); }
})();
})();
